import { TextField, TextFieldProps } from "@mui/material";
import { get } from "lodash";
import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";

type INumberFieldProps = {
  control: any;
  name: string;
  helperText: string;
  label: string;
  shrink?: boolean;
} & TextFieldProps;

export const InputNumber = (props: INumberFieldProps) => {
  const { control, name, helperText, label, shrink, ...otherProps } = props;
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={undefined}
      render={({ field: { onChange, ref, value } }) => {
        const onChangeField = (
          event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
        ) => {
          if (event.target.value === "") {
            onChange(undefined);
          } else {
            onChange(parseFloat(event.target.value));
          }
        };

        return (
          <TextField
            label={label}
            fullWidth
            ref={ref}
            error={!!errors[name]}
            type="number"
            sx={{ mb: "1rem" }}
            {...otherProps}
            InputLabelProps={{
              shrink: shrink,
            }}
            value={value}
            onChange={(event) => onChangeField(event)}
            helperText={
              get(errors, name)
                ? (get(errors, `${name}.message`) as unknown as string)
                : ""
            }
          />
        );
      }}
    />
  );
};
